import * as React from 'react';
import {
	ApIcon,
	ApMenuItem,
	ApMenuSection,
	colors,
} from '@alixpartners/ui-components';

import {
	ApMenuStyled,
	CheckIcon,
	DimensionDropdownLabelText,
	MenuLabel,
	PrevMenuLabel,
	MenuSectionLabel,
	NoDataWrapper,
	ItemsList,
} from './DimensionDropdown.styles';
import { SearchWrapper, StyledSearch } from '../SearchDialog.styles';

const buttonStyles = {
	alignItems: 'center',
	border: '1px solid transparent',
	borderRadius: '1px',
	boxSizing: 'border-box',
	color: colors.white,
	cursor: 'pointer',
	display: 'inline-flex',
	fontWeight: 500,
	height: '40px',
	justifyContent: 'center',
	lineHeight: '13px',
	minWidth: '32px',
	outline: 'none',
	overflow: 'visible',
	padding: '2px 8px',
	position: 'relative',
	textAlign: 'center',
	textDecoration: 'none',
	textTransform: 'uppercase',
	whiteSpace: 'nowrap',
	transition: 'all .2s linear',
	'.ap-icon': {
		margin: '0 4px 0 -2px',
		width: '18px',
	},
};

export const DimensionDropdown = ({
	options,
	selected,
	onChange,
	prevSelectedDimensions,
	isLoading,
}) => {
	const [search, setSearch] = React.useState('');
	const onSearchChange = query => {
		setSearch(query);
	};
	const onSearchClear = () => {
		setSearch('');
	};
	const filteredOptions = search
		? options.filter(({ label }) =>
				label.toLowerCase().includes(search.toLowerCase())
		  )
		: options;
	return (
		<ApMenuStyled
			button={props => (
				<button style={buttonStyles} {...props} disabled={isLoading}>
					<DimensionDropdownLabelText>
						{selected.label}
					</DimensionDropdownLabelText>
					<ApIcon
						iconName="caret"
						iconColor={props.isOpen ? colors.grey7 : colors.grey3}
					/>
				</button>
			)}
		>
			<SearchWrapper>
				<StyledSearch
					onChange={onSearchChange}
					onClear={onSearchClear}
					value={search}
				/>
			</SearchWrapper>
			<ItemsList>
				{prevSelectedDimensions.length ? (
					<ApMenuSection>
						<MenuSectionLabel onClick={() => {}}>Recent</MenuSectionLabel>
					</ApMenuSection>
				) : null}

				{prevSelectedDimensions.map(option => (
					<ApMenuItem
						key={`prev-${option.value}`}
						onClick={() => {
							onChange(option);
						}}
					>
						<PrevMenuLabel title={option.label}>{option.label}</PrevMenuLabel>
					</ApMenuItem>
				))}

				{prevSelectedDimensions.length ? (
					<ApMenuSection>
						<MenuSectionLabel onClick={() => {}}>
							All dimensions
						</MenuSectionLabel>
					</ApMenuSection>
				) : null}

				{filteredOptions.map(option => (
					<ApMenuItem
						key={`all-${option.value}`}
						onClick={() => onChange(option)}
						icon={
							<CheckIcon
								iconName="outline_done"
								visible={selected.value === option.value}
							/>
						}
					>
						<MenuLabel title={option.label}>{option.label}</MenuLabel>
					</ApMenuItem>
				))}
			</ItemsList>

			{search &&
				filteredOptions.length === 0 && (
					<NoDataWrapper>No results found</NoDataWrapper>
				)}
		</ApMenuStyled>
	);
};

export default DimensionDropdown;
